module.exports = __webpack_public_path__ + "img/nuvola_3.96644fdb.png";